import deepmerge from 'deepmerge';
import { withTheme } from 'emotion-theming';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';
import { themeGet } from '@styled-system/theme-get';

const getDefaultRFConfig = componentProps => ({
  chart: {
    type: 'scatter',
    zoomType: 'xy',
    style: {
      fontFamily: themeGet('fontFamily')(componentProps)
    }
  },
  title: {
    text: ''
  },
  credits: {
    enabled: false
  },
  plotOptions: {
    scatter: {
      marker: {
        radius: 7,
        states: {
          hover: {
            enabled: true,
            lineColor: 'rgb(100,100,100)'
          }
        }
      }
    }
  },
  legend: {
    layout: 'vertical',
    align: 'left',
    verticalAlign: 'top',
    x: 100,
    y: 40,
    floating: true,
    borderWidth: 1
  },
  tooltip: {
    formatter: function () {
      // prettier-ignore
      return `<div style="font-weight: bold; font-size: ${themeGet('fontSizes.1')(componentProps)};">${this.series.name}</div><br>
              <div style="font-size: ${themeGet('fontSizes.1')(componentProps)}; color: ${themeGet('colors.pink')(componentProps)};">x:${this.x} y:${this.y}</div>`;
    }
  },
  xAxis: {
    title: {
      text: 'X-Axis'
    },
    startOnTick: true,
    endOnTick: true,
    showLastLabel: true,
    labels: {
      style: {
        fontSize: themeGet('fontSizes.0')(componentProps)
      }
    }
  },
  yAxis: {
    title: {
      text: 'Y-Axis'
    },
    labels: {
      style: {
        fontSize: themeGet('fontSizes.0')(componentProps)
      }
    }
  },
  series: [{
    name: '',
    color: '',
    data: [],
    type: 'scatter'
  }]
});

const ScatterChart = withTheme(React.memo(props => {
  const defaultOptions = getDefaultRFConfig(props);
  const options = deepmerge(defaultOptions, props.options, {
    arrayMerge: (destinationArray, sourceArray) => sourceArray
  });
  options.chart.type = 'scatter';
  return React.createElement(HighchartsReact, {
    highcharts: Highcharts,
    options: options,
    ref: props.chartRef
  });
}));
export { ScatterChart };
//# sourceMappingURL=index.js.map
